/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-deprecated */
import React, { Component } from "react";

import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
  CSwitch
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  getAbilityName,
  getDisciplineName,
  getDisciplines
} from "../../../../utils/bncc";

class GeradorCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      user: {},
      loading: false,
      fields: [],
      series: [],
      all_series: [{ value: 0, label: "Carregando" }],
      creating: false,
      all_abilities: [],
      segments: [],
      ability: null,
      module: null,
      abilities: [],
      modules: [],
      discipline: "",
      disciplines: [],
      showPrintable: false,
      printable: false
    };

    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.formRef = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;

    // Checar se é o autor que está na página, senão, redireciona.
    if (id) {
      axios
        .get(`${URL.api}content/los/singleView/${id}`, {
          headers: {
            authorization: `Bearer ${this.props.user.token}`
          }
        })
        .then(resp => {
          if (resp.data.success) {
            if (resp.data.data.user_id !== this.props.user.user.id) {
              this.setState({ creating: true });
              this.props.history.push("/tools/gerador");
            }
          }
        });
    }

    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .all([
            axios.get(`${URL.api}content/type/list`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            }),
            axios.get(`${URL.api}classification/ability/filterStructure`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
          ])
          .then(
            axios.spread(
              (respType, respSegments) => {
                const fieldsArray = this.fieldsMount(
                  respType.data.data,
                  [],
                  [],
                  []
                );
                this.setState({ fields: fieldsArray }, () => {
                  if (!id) {
                    this.setState(() => ({
                      loading: false,
                      segments: respSegments.data.data
                    }));
                  } else {
                    axios
                      .get(`${URL.api}content/los/singleView/${id}`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(
                        resp => {
                          if (resp.data.success) {
                            let segment = null;

                            if (resp.data.data.series.length > 0) {
                              segment = resp.data.data.series[0].segment_id;
                            } else if (resp.data.data.segment_id) {
                              segment = resp.data.data.segment_id;
                            } else if (resp.data.data.module_segment_id) {
                              segment = resp.data.data.module_segment_id;
                            }

                            let discipline = null;
                            if (resp.data.data.discipline_id) {
                              discipline = resp.data.data.discipline_id;
                            } else if (resp.data.data.module_discipline_id) {
                              discipline = resp.data.data.module_discipline_id;
                            }

                            this.setState(() => ({
                              lo: resp.data.data,
                              path: resp.data.data.path,
                              image: resp.data.data.image,
                              edit: true,
                              loading: false,
                              series: resp.data.data.series.map(serie => ({
                                value: serie.id,
                                label: serie.name
                              })),
                              ability: resp.data.data.ability_id,
                              module: resp.data.data.module_id,
                              segment,
                              segments: respSegments.data.data,
                              discipline
                            }));
                          }
                        },
                        error => {
                          this.error("Não foi possível obter as informações");
                        }
                      );
                  }
                });
              },
              error => {
                this.error("Não foi possível obter as informações");
              }
            )
          );
      }
    );
  }

  fieldsMount(type, ability, skin, language) {
    let optionsType = [];
    for (let i = 0; i < type.length; i++) {
      if (i < type.length) {
        let obj = {
          value: type[i].id,
          name: type[i].name
        };
        optionsType[i] = obj;
      }
    }

    let optionsSkin = [];
    for (let i = 0; i < skin.length; i++) {
      let obj = {
        value: skin[i].id,
        name: skin[i].name
      };
      optionsSkin[i] = obj;
    }

    let optionsLanguage = [];
    for (let i = 0; i < language.length; i++) {
      let obj = {
        value: language[i].id,
        name: language[i].name
      };
      optionsLanguage[i] = obj;
    }

    let optionsBinary = [
      {
        value: false,
        name: "Não"
      },
      {
        value: true,
        name: "Sim"
      }
    ];

    let optionsStatus = [
      {
        value: "Em produção",
        name: "Em produção"
      },
      {
        value: "Liberado",
        name: "Liberado"
      }
    ];

    let defaultType = "";

    if (!this.state.edit) {
      const query = new URLSearchParams(window.location.search);
      defaultType = query.get("type");
    }

    let Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      },
      /* {
        name: "type_id",
        label: "Tipo",
        type: "select",
        required: true,
        icon: "fa fa-text-width",
        options: optionsType,
        value: defaultType,
        validate: [required, alphaNumeric]
      },
      {
        name: "flash",
        label: "Conteúdo Flash",
        type: "select",
        required: true,
        options: optionsBinary,
        icon: "fa fa-lock",
        value: false,
        validate: [required]
      }, */
      {
        name: "resume",
        label: "Resumo (Opcional)",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: []
      },
      {
        name: "objective",
        label: "Objetivo (Opcional)",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: []
      },
      {
        name: "year",
        label: "Ano",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
      // {
      //   name: "status",
      //   label: "Status",
      //   type: "select",
      //   required: true,
      //   icon: "fa fa-text-width",
      //   options: optionsStatus,
      //   value: "",
      //   validate: [required, alphaNumeric]
      // }
    ];

    return Fields;
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type_id: 31,
      path: "",
      ability_id: this.state.ability,
      module_id: this.state.module,
      released: true,
      private: false,
      flash: false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: null,
      resume: value.resume,
      objective: value.objective,
      image: this.state.image,
      author: "Educandus",
      language_id: 1,
      // status: value.status,
      status: "Em produção",
      year: value.year,
      source_id: 1,
      difficulty_level_id: 1,
      series: this.state.series.map(serie => serie.value),
      printable: this.state.showPrintable && this.state.printable
    };

    if (this.state.image === undefined) {
      toastr.error(
        "Falha",
        "Favor fazer o envio da imagem no início da página."
      );
      this.setState({ creating: false });
      // } else if (value.status === undefined) {
      //   toastr.error("Falha", "Favor inserir status da Aula");
      //   this.setState({ creating: false });
    } else if (this.state.series.length <= 0) {
      toastr.error(
        "Falha",
        "Favor inserir segmento, componente curricular e série"
      );
      this.setState({ creating: false });
    } else {
      axios
        .post(`${URL.api}content/los/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              const id = resp.data.data;
              this.props.history.push(`/tools/gerador/show/${id}`);
              this.setState({ creating: false });
            } else {
              this.error("Não foi possível inserir o LO");
              this.setState({ creating: false });
            }
          },
          error => {
            this.error("Não foi possível inserir o LO");
            this.setState({ creating: false });
          }
        );
    }
  }

  atualizar(value) {
    this.setState({ creating: true });

    let error = false;

    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      type_id: value.type_id,
      path: this.state.path,
      ability_id: this.state.ability,
      module_id: this.state.module,
      released: true,
      private: false,
      flash: value.flash,
      user_id: this.props.user.user.id,
      skin_id: 1,
      tag: null,
      resume: value.resume,
      objective: value.objective,
      image: this.state.image,
      author: "Educandus",
      language_id: 1,
      // status: value.status,
      year: value.year,
      source_id: 1,
      difficulty_level_id: 1,
      series: this.state.series.map(serie => serie.value),
      printable: this.state.showPrintable && this.state.printable
    };

    if (
      !(obj.flash.toString() === "true" || obj.flash.toString() === "false")
    ) {
      this.error("Preencha o campo 'Conteúdo Flash'");
      error = true;
    }

    if (!error) {
      axios
        .post(`${URL.api}content/los/update/${value.id}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.props.history.push("/tools/gerador");
              this.setState({ creating: false });
            } else {
              this.error("Não foi possível editar o LO");
              this.setState({ creating: false });
            }
          },
          error => {
            this.error("Não foi possível editar o LO");
            this.setState({ creating: false });
          }
        );
    } else {
      this.setState({ creating: false });
    }
  }

  done(uploads) {
    this.setState(() => ({
      image: URL.img + uploads[0]
    }));
  }

  changeSegment(e) {
    const segment = parseInt(e.target.value);

    this.setState({
      segment,
      series: [],
      ability: null,
      module: null,
      discipline: ""
    });
  }

  changeDiscipline(e) {
    const discipline = parseInt(e.target.value);
    this.setState({ discipline, series: [], ability: null, module: null });
  }

  render() {
    let defaultType = 1;

    if (!this.state.edit) {
      const query = new URLSearchParams(window.location.search);
      defaultType = query.get("type");
    }

    const segments =
      this.state.segments.filter(
        segment =>
          segment.disciplines.filter(
            discipline =>
              !!discipline.objectives.find(
                objective => objective.abilities.length > 0
              )
          ).length > 0
      ) || [];
    const disciplines =
      segments
        .find(segment => segment.id === this.state.segment)
        ?.disciplines.filter(
          discipline =>
            !!discipline.objectives.find(
              objective => objective.abilities.length > 0
            )
        ) || [];
    const objectives =
      disciplines.find(discipline => discipline.id === this.state.discipline)
        ?.objectives || [];

    const abilities = objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.abilities.map(ability => ({
          label: `(${ability.code}) ${ability.description}`,
          value: ability.id,
          objective: objective.id,
          series: ability.series
        }))
      }))
      .filter(objective => objective.options.length > 0);

    const modules = objectives
      .map(objective => ({
        label: objective.description,
        id: objective.id,
        options: objective.modules.map(module => ({
          label: module.description,
          value: module.id,
          objective: objective.id,
          series: module.series
        }))
      }))
      .filter(objective => objective.options.length > 0);

    const ability =
      abilities
        .reduce((acc, val) => [...acc, ...val.options], [])
        .find(ability => ability.value === this.state.ability) || null;
    const module =
      modules
        .reduce((acc, val) => [...acc, ...val.options], [])
        .find(module => module.value === this.state.module) || null;

    const series_abilities =
      ability?.series
        .filter(serie => serie.segment_id === this.state.segment)
        .map(item => ({
          label: item.name,
          value: item.id,
          order: item.order
        })) || [];
    const series_modules =
      module?.series
        .filter(serie => serie.segment_id === this.state.segment)
        .map(item => ({
          label: item.name,
          value: item.id,
          order: item.order
        })) || [];
    const series = [...series_abilities, ...series_modules]
      .filter((v, i, a) => a.findIndex(item => item.value === v.value) === i)
      .sort((a, b) => a.order - b.order);

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            {
              path: "/tools/gerador",
              to: `/tools/gerador`
            }
          ]}
        />
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit
                    ? "Editar Aula Gerador"
                    : "Criar Aula Gerador"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a Aula Gerador"
                    : "Crie uma nova Aula Gerador"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <CLabel className="d-flex align-items-center mb-2">
                Imagem do LO
                {this.state.image && (
                  <CBadge
                    color="primary"
                    className="ml-2"
                    href={this.state.image}
                    target="_blank"
                  >
                    Ver
                  </CBadge>
                )}
              </CLabel>
              <Uploader
                type="lo"
                maxFiles={1}
                acceptedFileTypes={["image/*"]}
                allowMultiple
                labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                done={uploads => this.done(uploads)}
              />
              <Form
                avatar
                fields={this.state.fields}
                back={false}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.lo}
                edit={this.state.edit}
                ref={this.formRef}
                onChange={e =>
                  this.setState({ showPrintable: e.type_id === "9" })
                }
              />
              {this.state.showPrintable && (
                <CFormGroup>
                  <CLabel>Material imprimível</CLabel>
                  <CInputGroup className="flex-nowrap">
                    <CSwitch
                      color="primary"
                      checked={this.state.printable}
                      onChange={e =>
                        this.setState({ printable: e.target.checked })
                      }
                      shape="pill"
                    />
                  </CInputGroup>
                </CFormGroup>
              )}
              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder="Segmento"
                    value={this.state.segment}
                    onChange={e => this.changeSegment(e)}
                  >
                    <option>Segmento</option>
                    {segments.map(segment => (
                      <option key={segment.id} value={segment.id}>
                        {segment.name}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>{getDisciplineName(this.state.segment)}</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    placeholder={getDisciplineName(this.state.segment)}
                    value={this.state.discipline}
                    onChange={e => this.changeDiscipline(e)}
                  >
                    <option>{getDisciplineName(this.state.segment)}</option>
                    {getDisciplines(this.state.segment, disciplines).map(
                      discipline => (
                        <option key={discipline.id} value={discipline.id}>
                          {discipline.name}
                        </option>
                      )
                    )}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CRow>
                <CCol>
                  <CFormGroup>
                    <CLabel>{getAbilityName(this.state.segment)}</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder={getAbilityName(this.state.segment)}
                        name={getAbilityName(this.state.segment)}
                        options={abilities}
                        value={ability}
                        noOptionsMessage={() => "Nada encontrado"}
                        className="basic-multi-select flex-1"
                        classNamePrefix="select"
                        onChange={e =>
                          this.setState({ ability: e.value, series: [] })
                        }
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
                <CCol>
                  <CFormGroup>
                    <CLabel>Módulo</CLabel>
                    <CInputGroup className="flex-nowrap">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-text-width"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder="Módulo"
                        name="Módulo"
                        options={modules}
                        value={module}
                        noOptionsMessage={() => "Nada encontrado"}
                        className="basic-multi-select flex-1"
                        classNamePrefix="select"
                        onChange={e =>
                          this.setState({ module: e.value, series: [] })
                        }
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
              </CRow>
              <CFormGroup>
                <CLabel>Séries</CLabel>
                <CInputGroup className="flex-nowrap">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Séries"
                    name="Séries"
                    noOptionsMessage={() => "Nada encontrado"}
                    options={series}
                    value={this.state.series}
                    className="basic-multi-select flex-1"
                    classNamePrefix="select"
                    onChange={e => this.setState({ series: e })}
                  />
                </CInputGroup>
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GeradorCreate);
